import { SHOPIFY_TEMPLATE_TYPES } from '~/constants/shopify';

/**
 * Dynamic Yield campaign names used across the site
 * Centralizing these constants ensures consistency and easier maintenance
 */

/**
 * Experiment types constants
 * Same as in site 1.0
 */
export const EXPERIMENT_TYPES = {
  API: 'API',
  EXPOSURE: 'exposure',
  RECOMMENDATION_API: 'Recommendation API',
  WEB_PERSONALIZATION: 'Web Personalization',
};

/**
 * Global campaigns that are used across multiple components
 */
export const GLOBAL_CAMPAIGNS = {
  // Add global campaigns here
  // Example: { experimentType: EXPERIMENT_TYPES.WEB_PERSONALIZATION, selectorName: 'Global Campaign Name' },
};

/**
 * Template-specific campaigns that are loaded only on specific page types
 * This allows easy addition of experiments for specific templates (PDP, homepage, etc.)
 */
export const TEMPLATE_CAMPAIGNS = {
  [SHOPIFY_TEMPLATE_TYPES.COLLECTION]: [
    // Add collection-specific campaigns here
    // Example: { experimentType: EXPERIMENT_TYPES.WEB_PERSONALIZATION, selectorName: 'Collection Layout Test' },
  ],
  [SHOPIFY_TEMPLATE_TYPES.INDEX]: [
    // Add homepage-specific campaigns here
    // Example: { experimentType: EXPERIMENT_TYPES.WEB_PERSONALIZATION, selectorName: 'Homepage Banner Test' },
  ],
  [SHOPIFY_TEMPLATE_TYPES.PRODUCT]: [
    // Add PDP-specific campaigns here
    // Example: { experimentType: EXPERIMENT_TYPES.WEB_PERSONALIZATION, selectorName: 'PDP Hero Layout' },
  ],
  // Add more template types and their specific campaigns as needed
};

/**
 * Recommendations campaigns selectors
 */
export const RECOMMENDATIONS_CAMPAIGNS = {
  [SHOPIFY_TEMPLATE_TYPES.ARTICLE]: {
    experimentType: EXPERIMENT_TYPES.RECOMMENDATION_API,
    selectorName: 'Article - Recs',
  },
  [SHOPIFY_TEMPLATE_TYPES.COLLECTION]: {
    experimentType: EXPERIMENT_TYPES.RECOMMENDATION_API,
    selectorName: 'Collection Personalized Merchandising',
  },
  [SHOPIFY_TEMPLATE_TYPES.INDEX]: {
    experimentType: EXPERIMENT_TYPES.RECOMMENDATION_API,
    selectorName: 'Homepage - Recs',
  },
  [SHOPIFY_TEMPLATE_TYPES.NOT_FOUND_ERROR]: {
    experimentType: EXPERIMENT_TYPES.RECOMMENDATION_API,
    selectorName: 'Not found - Recs',
  },
  [SHOPIFY_TEMPLATE_TYPES.PAGE]: {
    experimentType: EXPERIMENT_TYPES.RECOMMENDATION_API,
    selectorName: 'Page - Recs',
  },
  [SHOPIFY_TEMPLATE_TYPES.PRODUCT]: {
    experimentType: EXPERIMENT_TYPES.RECOMMENDATION_API,
    selectorName: 'PDP Sidebar Recs',
  },
};

/**
 * Campaign status constants
 */
export const CAMPAIGN_STATUS = {
  ERROR: 'error',
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
};

/**
 * Engagement types constants
 */
export const ENGAGEMENT_TYPES = {
  CLICK: 'CLICK',
  IMPRESSION: 'IMP',
  SLOT_CLICK: 'SLOT_CLICK',
  SLOT_IMPRESSION: 'SLOT_IMP',
};
